import { ImageRendition } from '../../utils/ImageUtils';

export type MLogoContainerColor = 'branded' | 'color' | 'grey' | 'white' | 'background-aware' | 'alternate-logo';
export type MLogoContainerAlignment = 'Bottom Left' | 'Center Left' | 'Bottom Centered' | 'Centered';

export interface MLogoContainerBaseProps {
  brand: string;
  backgroundColor?: string;
  color?: MLogoContainerColor;
  aspectRatio: string;
  width: number;
  height: number;
  alignment?: MLogoContainerAlignment;
  hoverColor?: string;
  ariaRole?: string;
  logopath?: string;
  aspectMode?: string;
  brandFullName?: string;
  /** DAC (Digital Asset Center) logo URL for regular image formats (PNG, JPG, etc.) */
  dacLogoUrl?: string;
  /** Flag to indicate if this is a DAC logo (true) or SVG logo (false) */
  isDACLogo?: boolean;
  /** Fetch priority for performance optimization - Note: Not supported by AImage, included for API consistency */
  fetchpriority?: 'high' | 'low' | 'auto';
  /** Control lazy loading. When false, image loads eagerly. Defaults to true */
  isLazy?: boolean;
  /** Custom CSS class to apply to the image element */
  customClass?: string;
  /** Renditions for dynamic image handling */
  renditions?: ImageRendition[];
  /** Whether the image is dynamic (affects URL construction) - Note: Not supported by AImage, included for API consistency */
  dynamic?: boolean;
}

export interface MLogoContainerAsLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  isLink: true;
  linkUrl: string;
}

export interface MLogoContainerAsSpanProps extends React.HTMLAttributes<HTMLSpanElement> {
  isLink?: false | undefined;
  linkUrl?: undefined;
}

export type MLogoContainerProps = (MLogoContainerAsSpanProps | MLogoContainerAsLinkProps) & MLogoContainerBaseProps;

export enum MLogoContainerBrand {
  MI = 'brand-logo-MI',
  MBS = 't-program-logo-color-s',
  JW = 'brand-logo-JW',
  RZ = 'brand-logo-rz',
}

export enum MLogoContainerSize {
  S = 's',
  M = 'm',
  L = 'l',
}
